import React, { useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import { useNavigateTo } from 'infrastructure/routing'
import { makeKiddomDeleteRequest } from 'infrastructure/api'
import { useNotify } from 'shared/ui/Notify'

const DeleteOrgUsersButton = ({
  name,
  resource,
  schoolID,
  districtID,
}: {
  name: string
  resource: string
  schoolID?: number
  districtID?: number
}) => {
  const [open, setOpen] = useState(false)
  const navigate = useNavigateTo()
  const notify = useNotify()
  const redirect = () => {
    if ((districtID && schoolID) || districtID) {
      navigate(`/districts/${districtID}/show`)
    } else if (schoolID) {
      navigate(`/schools/${schoolID}/show`)
    }
  }

  const doDelete = async () => {
    let url = ''
    if (schoolID) {
      url = `/v1/kat/schools/${schoolID}/users`
    } else if (districtID) {
      url = `/v1/kat/districts/${districtID}/users`
    }
    try {
      const { error } = await makeKiddomDeleteRequest<
        undefined | { error?: unknown }
      >({ kiddomPath: url })
      if (error != null) {
        notify(error, { type: 'error' })
      } else {
        redirect()
      }
    } catch {
      notify('Error occured during api call, contact rostering team', {
        type: 'error',
      })
    }
  }
  const title =
    'Are you sure you want to delete the users for this ' + resource + '?'
  const buttonText = 'Delete ' + resource + ' Users'

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <Button variant="outlined" color="primary" onClick={handleClickOpen}>
        {buttonText}
      </Button>
      <Dialog onClose={handleClose} open={open} data-testid="dialog">
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <span>
              {resource} Name: {name}
            </span>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>No</Button>
          <Button onClick={doDelete}>Yes</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default DeleteOrgUsersButton
